
// src/services/api.js  (Vue 2 safe)
// - Sem optional chaining
// - Refresh no web via cookie (withCredentials: true)
// - AccessToken no localStorage
// - Evita tempestade de refresh (fila)

import router from "@/router";
import store from "@/store";
import { getOrCreateDeviceId } from '@/utils/device-id';
import axios from "axios";
import { BASE_CONSTANTS } from "./config";

var TOKEN_KEY = "authorization";

function getAccessToken() {
  try {
    return JSON.parse(localStorage.getItem(TOKEN_KEY) || "null");
  } catch (e) {
    return null;
  }
}

function setAccessToken(token) {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
}

function clearAccessToken() {
  store.dispatch('auth/logout');
}

function goToLogin() {
  try {
    // evita empilhar navegação/loop
    if (router.currentRoute && router.currentRoute.name !== "Login") {
      router.replace({ name: "Login" });
    }
  } catch (e) {
    // fallback (caso router ainda não tenha inicializado por algum motivo)
    window.location.href = "/login";
  }
}

function goToSessionExpired() {
  try {
    if (router.currentRoute && router.currentRoute.name !== "SessaoExpirada") {
      router.replace({ name: "SessaoExpirada" });
    }
  } catch (e) {
    window.location.href = "/sessao-expirada";
  }
}


export var api = axios.create({
  //baseURL: process.env.VUE_APP_API_URL || "http://localhost:5477",
  baseURL: BASE_CONSTANTS.urlBase,
  headers: {
    "Content-Type": "application/json",
    'X-Client': 'WEB',
    'X-Platform': 'BROWSER',
    'X-App-Version': BASE_CONSTANTS.versao,
    'X-Device-Id': ''
  },
  withCredentials: true, // 🔑 necessário para enviar cookie refreshToken no /auth/refresh e /auth/logout
});

// 1) Request interceptor: injeta Bearer
api.interceptors.request.use(
  function (config) {

    var url = config.url || "";

    // Não injeta Authorization em endpoints de auth que não precisam
    if (url.indexOf("auth/refresh") >= 0 || url.indexOf("auth/login") >= 0) {
      return config;
    }

    var token = getAccessToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = "Bearer " + token;
    }
    config.headers['X-Device-Id'] = getOrCreateDeviceId()

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Controle de refresh concorrente
var isRefreshing = false;
var pending = [];

function resolvePending(newToken) {
  for (var i = 0; i < pending.length; i++) {
    pending[i].resolve(newToken);
  }
  pending = [];
}

function rejectPending(err) {
  for (var i = 0; i < pending.length; i++) {
    pending[i].reject(err);
  }
  pending = [];
}

// 2) Response interceptor: em 401 tenta refresh e repete request
api.interceptors.response.use(
  function (res) {
    return res;
  },
  function (err) {
    var status = err && err.response ? err.response.status : null;
    var original = err ? err.config : null;

    if (!original) return Promise.reject(err);

    // evita loop
    if (status !== 401 || original._retry) {
      return Promise.reject(err);
    }

    // não tenta refresh nos endpoints de auth (evita loop)
    var url = original.url || "";
    console.log(url)
    if (url.indexOf("auth/login") >= 0 || url.indexOf("auth/refresh") >= 0) {
      return Promise.reject(err);
    }

    original._retry = true;

    // se já tem refresh em andamento, aguarda
    if (isRefreshing) {
      return new Promise(function (resolve, reject) {
        pending.push({ resolve: resolve, reject: reject });
      }).then(function (newToken) {
        original.headers = original.headers || {};
        original.headers.Authorization = "Bearer " + newToken;
        return api(original);
      });
    }

    isRefreshing = true;

    // chama refresh (cookie vai automaticamente)
    return api
      .post("auth/refresh", {})
      .then(function (resp) {
        // Ajuste aqui se o campo do seu TokenResponse for diferente
        var newToken = resp && resp.data ? resp.data.accessToken : null;

        if (!newToken) {
          throw new Error("Refresh não retornou accessToken");
        }

        setAccessToken(newToken);
        resolvePending(newToken);

        // repete request original
        original.headers = original.headers || {};
        original.headers.Authorization = "Bearer " + newToken;
        return api(original);
      })
      .catch(function (refreshErr) {
        rejectPending(refreshErr);
        clearAccessToken();
        goToSessionExpired();
        return Promise.reject(refreshErr);
      })
      .finally(function () {
        isRefreshing = false;
      });
  }
);

// helpers opcionais (p/ usar no login/trocar-perfil)
export function saveAccessTokenFromResponse(tokenResponse) {
  if (tokenResponse && tokenResponse.accessToken) {
    setAccessToken(tokenResponse.accessToken);
  }
}

export function logoutLocal() {
  clearAccessToken();
}
